import { Container } from "@fideus-ui/core";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { TaskTab } from "../../../companies/tasks/TaskTab";

const companyRoute = getRouteApi("/firmen/$companyId");

export const Route = createFileRoute("/firmen/$companyId/aufgaben")({
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.tasks.listTasksByCompanyId.queryOptions({ companyId })
    );
  },
  component: AufgabenRoute,
});

function AufgabenRoute() {
  const { companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();
  return (
    <Container>
      <TaskTab companyId={companyId} selectedYear={jahr} />
    </Container>
  );
}
